import { urls } from "venuescanner-js/services/endPoints";

const setMethods = (model) => {
  model.getPhoto = (size = "med") => {
    if (model._subjects._value.photos.length) {
      return `${urls.PHOTOS_URL}/${model.venue._subjects._value.hashcode}/${size}_${model._subjects._value.photos[0].filename}`;
    } else if (model.venue) {
      return model.venue.getPhoto(size);
    }
  };
};
export default setMethods;
